import { DateTime } from 'luxon';
import { Component } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { NumberplateScanResult, NumberplateScanResults } from './numberplate-scans.model';
import { AbstractWidgetComponent, ContextChange, AppServerAPI, AppClientConfiguration } from '@sdbn/common';

@Component({
    selector: 'app-numberplate-scans',
    templateUrl: './numberplate-scans.component.html',
    styleUrls: ['./numberplate-scans.component.scss'],
    standalone: false
})
export class NumberPlateScansComponent extends AbstractWidgetComponent {

  entrance1: NumberplateScanResult;
  leave1: NumberplateScanResult;

  entrance2: NumberplateScanResult
  leave2: NumberplateScanResult;

  refreshEnabled = true;
  refreshInterval = 30000;
  refreshTimer: Subscription;

  displayTimeout: 30;

  constructor(
    private appServerAPI: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {

  }
  onSetElementAndContext() {
    this.loadLatestNumberplateScans();
    this.displayTimeout = this.widgetReference.data?.displayTimeout ?? 30;
    this.refreshEnabled = this.widgetReference.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 5 * 1000;
    }
    this.registerRefreshTimer();
  }

  private registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }

    if (this.appClientConfiguration.autoreload && this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(() => {
        this.loadLatestNumberplateScans();
      }
      );
    } else {
      console.log('Autoreload numberplate scan results disabled');
    }
  }

  private loadLatestNumberplateScans() {
    this.appServerAPI.execute<any>('/client/control/scan-numberplate/getLastScannedNumberplates', '').subscribe(
      result => {
        this.clear();
        const scanResults = new NumberplateScanResults(result);
        scanResults?.numberplateScans?.forEach(s => {
          const scannedAt = DateTime.fromFormat(s.scannedAt, 'yyyyMMddHHmmss');
          if (!scannedAt.isValid || scannedAt.diffNow('seconds').values.seconds < -this.displayTimeout) {
            console.log('outdated');
          } else {
            if (s.cameraIdentifier === 'Einfahrt 1') {
              this.entrance1 = s;
            } else if (s.cameraIdentifier === 'Einfahrt 2') {
              this.entrance2 = s;
            } else if (s.cameraIdentifier === 'Ausfahrt 1') {
              this.leave1 = s;
            } else if (s.cameraIdentifier === 'Ausfahrt 2') {
              this.leave2 = s;
            }
          }
        });
      },
      error => {
        console.log('Failed to load numberplate scan results', error);
      }
    );
  }

  private clear() {
    this.entrance1 = null;
    this.leave1 = null;
    this.entrance2 = null;
    this.leave2 = null;
  }

}
